import { useCallback, useMemo, useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router-dom'
import Status from '../../../../components/Status/Status'
import { Container } from '../../../../components/Container/Container'
import { Menu } from '../../../../components/Menu/Menu'
import { HealthSystemUsers } from '../HealthSystemUsers/HealthSystemUsers'
import { GeneralDetails } from './General/GeneralDetails'
import { setLoading } from '../../../../redux/store/common/slice'
import { getHealthSystemDetails } from './api'
import useRouter from '../../../../hooks/useRouter'
import { HEALTH_SYSTEM_STATUSES_CLASSNAME } from '../../../../components/Status'
import {
  BREADCRUMBS,
  HEALTH_SYSTEM_DETAILS_TABS,
  HEALTH_SYSTEM_DETAILS_TABS_KEYS,
  initialHealthSystemDetails
} from './constants'
import { HealthSystemDetailsData } from './types'
import './styles.scss'
import { Typography } from 'components/Typography'

export const HealthSystemDetails = () => {
  const [data, setData] = useState<HealthSystemDetailsData>(
    initialHealthSystemDetails
  )

  const { id: hsId, tab } = useParams()
  const dispatch = useDispatch()
  const router = useRouter()
  const [activeTab, setActiveTab] = useState(
    tab || HEALTH_SYSTEM_DETAILS_TABS_KEYS.general
  )
  const status = data?.status

  useEffect(() => {
    if (hsId) {
      getDetails(hsId)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [hsId])

  useEffect(() => {
    setActiveTab(tab || HEALTH_SYSTEM_DETAILS_TABS_KEYS.general)
  }, [tab])

  const getDetails = useCallback(
    async (hsId: string) => {
      try {
        dispatch(setLoading(true))
        const { data } = await getHealthSystemDetails(hsId)
        setData(data)
      } finally {
        dispatch(setLoading(false))
      }
    },
    [dispatch]
  )

  const RenderedMenu = useMemo(() => {
    const handleSelectTab = (e) => {
      setActiveTab(e.key)
      router.push(e.key)
    }

    return (
      <Menu
        mode="horizontal"
        onSelect={handleSelectTab}
        selectedKeys={[activeTab]}
        defaultSelectedKeys={[activeTab]}
        items={HEALTH_SYSTEM_DETAILS_TABS}
      />
    )
  }, [activeTab, router])

  const RenderedStatus = useMemo(
    () =>
      status ? (
        <Status.Default className={HEALTH_SYSTEM_STATUSES_CLASSNAME[status]}>
          {status}
        </Status.Default>
      ) : null,
    [status]
  )

  const title = useCallback(() => {
    return (
      <div className="column gap-8">
        {data?.name}
        {data?.community_name && (
          <Typography.Body1 className="grey-text">
            {data?.community_name}
          </Typography.Body1>
        )}
      </div>
    )
  }, [data])

  return (
    <Container
      title={title()}
      breadcrumbs={BREADCRUMBS(data?.name || '')}
      menu={RenderedMenu}
      status={RenderedStatus}
    >
      {activeTab === HEALTH_SYSTEM_DETAILS_TABS_KEYS.general && (
        <GeneralDetails data={data} />
      )}
      {!activeTab && <GeneralDetails data={data} />}
      {activeTab === HEALTH_SYSTEM_DETAILS_TABS_KEYS.users && (
        <HealthSystemUsers hsId={hsId as string} />
      )}
    </Container>
  )
}
